(() => {
  const root = window.Shopify?.routes?.root || '/';
  const groupOf = item => item.properties?.['_Card order'];
  const isFee = item => Boolean(groupOf(item) && item.properties?.['For card'] && item.properties?.['Card package']);
  const isCard = item => Boolean(groupOf(item) && !isFee(item) && item.properties?.['Design service']);
  const orphanUpdates = cart => {
    const groups = new Set(cart.items.filter(isCard).map(groupOf));
    return Object.fromEntries(cart.items.filter(item => isFee(item) && !groups.has(groupOf(item))).map(item => [item.key, 0]));
  };
  const needsFee = item => Boolean(item.properties?.['_Design service variant']) ||
    !/^Print-ready artwork\s*\/\s*unchanged reorder\s*[—-]\s*included$/i.test(String(item.properties?.['Design service'] || '').trim());
  const missingFees = cart => cart.items.filter(isCard).filter(needsFee).filter(card => {
    const expected = String(card.properties?.['_Design service variant'] || '');
    return !cart.items.some(fee => isFee(fee) && groupOf(fee) === groupOf(card) && Number(fee.quantity) > 0 &&
      (!expected || String(fee.variant_id || fee.id) === expected));
  });
  const read = async () => {
    const response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const update = async updates => {
    const response = await fetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates})});
    const cart = await response.json();
    if (!response.ok || cart.status) throw new Error('cart');
    return cart;
  };
  let pending = Promise.resolve(), busy = 0, failed = false, invalid = false;
  const buttons = new Map(), express = new Map();
  const checkoutSelector = '[name="checkout"], a[href*="/checkout"], [data-hg-checkout-blocked]';
  const lock = () => {
    document.querySelectorAll(checkoutSelector).forEach(button => {
      if (!buttons.has(button)) buttons.set(button, {disabled: button.disabled, aria: button.getAttribute('aria-disabled')});
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
    document.querySelectorAll('.additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"], .dynamic-checkout__content').forEach(element => {
      if (!express.has(element)) express.set(element, element.style.display);
      element.style.display = 'none';
    });
  };
  const unlock = () => {
    buttons.forEach((state, button) => {
      if (!button.isConnected) return;
      button.disabled = state.disabled;
      if (state.aria === null) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled', state.aria);
    });
    buttons.clear();
    express.forEach((display, element) => { if (element.isConnected) element.style.display = display; });
    express.clear();
  };
  const statusMessage = message => {
    const page = document.querySelector('#CartPageForm');
    const visible = element => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
    const host = page || [...document.querySelectorAll('#CartDrawer, form[action$="/cart"]')].find(visible);
    if (!host) return;
    let status = host.querySelector('[data-hg-card-cart-status]');
    document.querySelectorAll('[data-hg-card-cart-status]').forEach(other => {
      if (other !== status) other.textContent = '';
    });
    if (!status && message) {
      status = document.createElement('p');
      status.dataset.hgCardCartStatus = '';
      status.setAttribute('role', 'alert');
      host.prepend(status);
    }
    if (status) status.textContent = message;
  };
  const report = () => {
    failed = true;
    lock();
    statusMessage(document.querySelector('[data-hg-card-cart-script]')?.dataset.error || 'We could not verify your print and design items. Refresh the cart before checking out.');
  };
  const audit = cart => {
    invalid = missingFees(cart).length > 0;
    if (invalid) {
      lock();
      statusMessage(document.querySelector('[data-hg-card-cart-script]')?.dataset.missingDesign || 'A print package still requests paid design work, but its matching design service was removed. Open that product from the cart, choose the correct artwork/design option and add it again, then remove the old package. Checkout is paused until the package and design service match.');
    } else if (!failed) statusMessage('');
  };
  const run = action => {
    busy++;
    lock();
    const job = pending.then(action);
    pending = job.catch(() => {}).finally(() => {
      if (--busy === 0 && !failed && !invalid) unlock();
    });
    return job;
  };
  const normalize = cart => run(async () => {
    const current = await read();
    audit(current);
    const updates = orphanUpdates(current);
    if (!Object.keys(updates).length) return;
    await update(updates);
    window.location.reload();
  }).catch(report);
  if (window.theme?.cart?.changeItem) {
    const original = theme.cart.changeItem;
    theme.cart.changeItem = function(key, quantity) {
      const context = this;
      return run(async () => {
        const changeAndAudit = async () => {
          const result = await original.call(context, key, quantity);
          audit(await read());
          return result;
        };
        if (Number(quantity) !== 0) return changeAndAudit();
        const cart = await read();
        const card = cart.items.find(item => item.key === key);
        if (!card || !isCard(card)) return changeAndAudit();
        const updates = {[key]: 0};
        const hasSibling = cart.items.some(item => item.key !== key && isCard(item) && groupOf(item) === groupOf(card));
        if (!hasSibling) cart.items.filter(item => isFee(item) && groupOf(item) === groupOf(card)).forEach(item => { updates[item.key] = 0; });
        const result = await update(updates);
        audit(result);
        return JSON.stringify(result);
      }).catch(error => { report(); throw error; });
    };
  }
  document.addEventListener('submit', event => {
    if ((busy || failed || invalid) && (event.submitter?.name === 'checkout' || /\/checkout(?:[/?#]|$)/.test(event.target?.action || ''))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    if ((busy || failed || invalid) && event.target.closest?.(checkoutSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  new MutationObserver(() => { if (busy || failed || invalid) lock(); }).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('cart:updated', event => {
    if (event.detail?.cart?.items) normalize(event.detail.cart);
  });
  if (document.querySelector('#CartPageForm')) normalize();
})();

